import Point from '@arcgis/core/geometry/Point';
import * as geoUnion from '@arcgis/core/geometry/operators/unionOperator';

/**
 * ポップアップ設定
 */
export function popupConfig(customProps) {
  return {

    // クローズボタン以外を消す
    visibleElements: {
      actionBar: false,             // 操作バーを消す
      collapseButton: false,        // 開閉ボタンを消す
      featureNavigation: false,     // 複数選択矢印を消す
      featureMenuHeading: false,
      featureListLayerTitle: false,
    },

    // ズームボタンを消す
    viewModel: {
      includeDefaultActions: false,
    },

    // ドッキングを無効化
    dockEnabled: false,
    dockOptions: {
      buttonEnabled: false,
      breakpoint: false,
    },

    // カスタム設定
    ...customProps,
  };
};

/**
 * 電柱一覧の中央に移動
 */
export function moveCenter(view, poleList = [], options = GOTO_OPTIONS) {

  // 一覧が空なら移動しない
  if (poleList.length === 0) {
    return;
  }

  // 一覧の中央を表示
  const first = poleList[0];
  const min = { lat: first.latitude, lon: first.longitude };
  const max = { lat: first.latitude, lon: first.longitude };
  for (const pole of poleList) {
    min.lat = Math.min(min.lat, pole.latitude);
    min.lon = Math.min(min.lon, pole.longitude);
    max.lat = Math.max(max.lat, pole.latitude);
    max.lon = Math.max(max.lon, pole.longitude);
  }
  const center = [
    (min.lon + max.lon) / 2,
    (min.lat + max.lat) / 2,
  ];
  view.goTo({ center }, options)
      .catch((err) => console.info('Map error:', err.message));
}

/**
 * 電柱一覧の全体を表示
 */
export function showAll(view, poleList = [], options = GOTO_OPTIONS) {
  if (!view) return;

  // 一覧がからなら何もしない
  if (poleList.length === 0) {
    return;
  }

  // 1件のみなら中央に表示
  if (poleList.length === 1) {
    const pole = poleList.at(0);
    const center = [ pole.longitude, pole.latitude ];
    view.goTo(center, options)
        .catch((err) => console.info('Map error:', err.message));
    return;
  }

  // 複数件なら全体を表示
  const geometries = poleList.map((pole) => new Point({
    latitude: pole.latitude,
    longitude: pole.longitude,
  }));
  const extent = geoUnion.executeMany(geometries).extent.expand(1.05);
  view.goTo(extent, options)
      .catch((err) => console.info('Map error:', err.message));
}

// 地図移動オプション
const GOTO_OPTIONS = {
  animate: true,
  duration: 1000,
};

// デフォルトエクスポート
export default {
  popupConfig,
  moveCenter,
  showAll,
  GOTO_OPTIONS,
};
